import { useTranslation } from 'react-i18next';
import { Form } from '@components/ui/form';
import { FormRequired } from '@components/ui/form/required';
import { FormField, FormMessage } from '@components/ui/form';
import { SchedulerShell } from '@components/scheduling/shell';
import { SchedulerBlock } from '@components/scheduling/block';
import { formatTime, shortDate, shortDay } from '@utils/i18n';
import { ExternalScheduleMobileLayoutProps } from './types';
import { Reveal } from '@components/ui/reveal';

export const ExternalScheduleMobileLayout = ({
  open,
  setOpen,
  title,
  form,
  onSubmit,
  when,
  related,
  banners,
  children,
  details,
  confirmed,
  actions,
}: ExternalScheduleMobileLayoutProps) => {
  const { t } = useTranslation('app');
  const date = form.watch('date');
  const time = form.watch('time');

  return (
    <Form {...form}>
      <SchedulerShell
        open={open}
        onOpenChange={setOpen}
        title={title}
        renderWhen={when}
        summary={
          <>
            <b>{date ? `${shortDay(date)}, ${shortDate(date)}` : t('forms.date.label')}</b>
            {time && <span>· {formatTime(time)}</span>}
          </>
        }
        footerExtra={confirmed}
        footer={
          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit();
            }}>
            <div className="[&>div>div]:contents [&>div]:grid [&>div]:auto-cols-fr [&>div]:grid-flow-col [&>div]:gap-2 [&_button]:h-11 [&_button]:w-full [&_button]:justify-center [&>div>span]:w-full">
              {actions}
            </div>
          </form>
        }>
        {banners}
        <Reveal show={Boolean(related)} className="-mb-2" contentClassName="pb-2">
          <SchedulerBlock title={t('scheduling.relatedSchedules')}>{related}</SchedulerBlock>
        </Reveal>
        <SchedulerBlock className="flex flex-col gap-4 [&>div]:flex-col [&>div]:gap-4 [&_.h-8]:h-11">
          {children}
        </SchedulerBlock>
        {details && (
          <SchedulerBlock className="flex flex-col gap-4 [&_.h-8]:h-11">{details}</SchedulerBlock>
        )}
        <SchedulerBlock className="py-2">
          <FormRequired />
          <FormField name="root" render={() => <FormMessage />} />
        </SchedulerBlock>
      </SchedulerShell>
    </Form>
  );
};
